import { render, staticRenderFns } from "./ReplayData.vue?vue&type=template&id=708409e0&scoped=true"
import script from "./ReplayData.vue?vue&type=script&lang=js"
export * from "./ReplayData.vue?vue&type=script&lang=js"
import style0 from "./ReplayData.vue?vue&type=style&index=0&id=708409e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708409e0",
  null
  
)

export default component.exports